import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  CreateEntityRelativeQuantityData,
  EntityRelativeQuantityApi,
  EntityRelativeQuantityQuery,
  UpdateEntityRelativeQuantityData,
} from 'api';

const DEFAULT_QUANTITY = { few_product: 10, have_product: 20 };

export const findEntityRelativeQuantity = createAsyncThunk(
  'entityRelativeQuantity/findEntityRelativeQuantity',
  async (params: EntityRelativeQuantityQuery, { rejectWithValue }) => {
    try {
      const response = await EntityRelativeQuantityApi.filter(params);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityRelativeQuantity = createAsyncThunk(
  'entityRelativeQuantity/createEntityRelativeQuantity',
  async (body: CreateEntityRelativeQuantityData, { rejectWithValue }) => {
    try {
      const response = await EntityRelativeQuantityApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityRelativeQuantity = createAsyncThunk(
  'entityRelativeQuantity/updateEntityRelativeQuantity',
  async (
    params: { id: string; body: UpdateEntityRelativeQuantityData },
    { rejectWithValue }
  ) => {
    try {
      const { id, body } = params;
      const response = await EntityRelativeQuantityApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  list: Array<any>;
  quantity: any;
}

const initialState: IState = {
  list: [],
  quantity: {},
};

const entityRelativeQuantitySlice = createSlice({
  name: 'entityRelativeQuantity',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(findEntityRelativeQuantity.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.quantity = data[0]?.quantity || DEFAULT_QUANTITY;
    });
    builder.addCase(createEntityRelativeQuantity.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.quantity = data?.quantity || DEFAULT_QUANTITY;
    });
    builder.addCase(updateEntityRelativeQuantity.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.quantity = data?.quantity || DEFAULT_QUANTITY;
    });
  },
});

const { reducer: entityRelativeQuantityReducer } = entityRelativeQuantitySlice;

export default entityRelativeQuantityReducer;
